module.exports = __webpack_public_path__ + "img/blue_background2.c9aa0813.jpg";